import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { SeverityLevel } from '@sentry/browser';
import { TENANT_NAME } from 'src/config';

export enum SentrySeverityLevel {
  Error = 'error',
  Debug = 'debug',
  Message = 'message',
  Critical = 'critical',
  Fatal = 'fatal',
  Warning = 'warning',
}
@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor() {}

  public settenantInfo() {
    const tags = { tenant: TENANT_NAME };
    Sentry.setTags(tags);
    Sentry.setContext('Tenant info', tags);
  }

  public setUserInfo(weguideId) {
    const tags = { weguideID: weguideId };
    Sentry.setTags(tags);
    Sentry.setContext('Debug User info', tags);
  }

  public setProgramInfo(questionnaireId) {
    const tags = { questionnaireID: questionnaireId };
    Sentry.setTags(tags);
    Sentry.setContext(' Debug Questionniare info', tags);
  }

  public setMessageForSentry(message: string, level: string) {
    Sentry.captureMessage(message, level as SeverityLevel);
  }
  public setMessageForSentryWithErrorInfo(message: string, level: string, extras: Record<string, unknown>) {
    Sentry.withScope(scope => {
      scope.setExtra('extra', extras);
      Sentry.captureMessage(message, level as SeverityLevel);
    });
  }
}
